export const SIDES = {
    FRONT: 'front',
    BACK: 'back'
};
